module.exports = __webpack_public_path__ + "static/img/一键掌控，多银行账户尽在掌中，智能登录，开启金融管理的“自动驾驶”.1d83c4e4.png";